module.exports = __webpack_public_path__ + "static/media/class_job_023.1a6202aa.svg";